'use client';

import { useClarityIdentify } from '@/hooks/use-clarity-identify';

export function ClarityIdentity(): null {
  useClarityIdentify();
  return null;
}
